import { CommerceToolsApi } from '@grandvisionhq/commercetools';

const defaultProductKey = 'sunglasses';
const getProductKeyFromCTType = (productType)=>{
    if (CommerceToolsApi.isSunglasses(productType)) {
        return 'sunglasses';
    } else if (CommerceToolsApi.isFrames(productType)) {
        return 'frames';
    } else if (CommerceToolsApi.isAccessories(productType)) {
        return 'accessories';
    } else if (CommerceToolsApi.isSolutions(productType)) {
        return 'solutions';
    } else if (CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType)) {
        return 'contact-lenses';
    } else if (CommerceToolsApi.isReadyReaders(productType)) {
        return 'ready-readers';
    }
    return defaultProductKey;
};

export { getProductKeyFromCTType };
//# sourceMappingURL=get-product-key-from-ct-type.js.map
